import { render, staticRenderFns } from "./FarmList.vue?vue&type=template&id=63ca2537&scoped=true"
import script from "./FarmList.vue?vue&type=script&lang=js"
export * from "./FarmList.vue?vue&type=script&lang=js"
import style0 from "./FarmList.vue?vue&type=style&index=0&id=63ca2537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca2537",
  null
  
)

export default component.exports